import { IconDot } from '@/assets';
import HoverGridCanvas from '@/components/common/HoverGridCanvas';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionMission = () => {
  const { t } = useTranslation();
  const competitiveAdvantages = [
    {
      number: '01',
      title: t('Customized Solutions'),
      desc: t(
        'Deliver solutions tailored to client needs by integrating the latest technology and proven methodologies.'
      ),
    },
    {
      number: '02',
      title: t('Technical Strategies'),
      desc: t(
        `Create strategies that align technological advancements with customer business objectives.`
      ),
    },
    {
      number: '03',
      title: t('Scalable Infrastructure'),
      desc: t(
        'Provide customized solutions combining the latest technology and proven methodologies.'
      ),
    },
    {
      number: '04',
      title: t('Transparent Communication'),
      desc: t('Foster trust through clear, honest communication and close collaboration.'),
    },
    {
      number: '05',
      title: t('Continuous Innovation'),
      desc: t('Stay ahead with consistent learning and adoption of cutting-edge technologies.'),
    },
  ];
  return (
    <section className="competitive-advantages section-mission">
      <HoverGridCanvas />
      <div className="competitive-advantages__content">
        <p className="title">{t('Mission')}</p>
        <div className="list-items">
          {competitiveAdvantages.map((item, index) => (
            <div className="item" key={item.number}>
              <div className="item__top">
                <span className="number">{item.number}</span>
                <span className="title-item">{item.title}</span>
              </div>
              <div className="item__bottom">
                <div className="flex">
                  <div className="icon-dot">
                    <IconDot />
                  </div>
                  <span className="desc">{item.desc}</span>
                </div>
                <div className="icon-dot">
                  <IconDot />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(SectionMission);
